// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import usePrevious from "@insite/client-framework/Common/Hooks/usePrevious";
import { useCurrentCartState } from "@store/Framework/Store/Data/Carts/CartsHooks";
import { FC, useEffect, useState } from "react";

export interface SignifydFingerprintProps {
    cookie?: string;
}

const SignifydFingerprint: FC<SignifydFingerprintProps> = ({ cookie = "SignifydSessionId" }) => {
    const orderNumber = useCurrentCartState().value?.orderNumber;
    const [sessionId, setSessionId] = useState(getCookie(cookie));
    const previousOrderNumber = usePrevious(orderNumber);

    useEffect(() => {
        if (orderNumber && previousOrderNumber) {
            setSessionId(getCookie(cookie));
        }
    }, [orderNumber]);

    useEffect(() => {
        if (sessionId) {
            const script = document.createElement("script");

            script.type = "text/javascript";
            script.id = "sig-api";
            script.src = "https://cdn-scripts.signifyd.com/api/script-tag.js";
            script.setAttribute("data-order-session-id", sessionId);
            script.defer = true;

            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, [sessionId]);

    return null;
};

export default SignifydFingerprint;
